import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListNguonVon, updateDataSearch } from "../../actions/NguonVon";
import { formatNumber } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactDropdown from "react-dropdown";
import { formatDayMonth } from "utils/formatDate";
import NguonVonApi from "../../service/nguonVonApi";
export const SearchBarDesktop = ({}) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  const initGiaoDich = {
    listGiaoDich: [
      {
        label: "Tất cả",
        value: "0",
      },
    ],
  };
  const [loaiGiaoDich, setLoaiGiaoDich] = useState(initGiaoDich.listGiaoDich);

  useEffect(() => {
    NguonVonApi.loaiGiaoDich().then((response) => {
      const dataComboLoai = response.data.List.map((item) => ({
        value: item.Value,
        label: item.Text,
      }));
      setLoaiGiaoDich(dataComboLoai);
    });
  }, []);
  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dispatch(getListNguonVon(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListNguonVon(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  return (
    <div className="search-new hidden-mobile-main show-table-main">
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tên cổ đông</label>
        <input
          type="email"
          className="form-control input-sm "
          id="email-addr"
          placeholder="Tên cổ đông"
          value={dataSearch.ten}
          onChange={updateTextValue("ten")}
          onKeyDown={handleKeyDown}
        />
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Loại giao dịch</label>
        <select
          name="loaigiaodich"
          className="selectBox form-control input-sm"
          value={dataSearch.loaigiaodich}
          onChange={updateDropdown("loaigiaodich")}
        >
          {loaiGiaoDich &&
            loaiGiaoDich.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18 search-main-new">

        <button
          type="submit"
          className="btn btn-info-new"
          style={{ marginTop: "28px", paddingTop: "7px" }}
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  );
};
